import React from 'react';
import classNames from 'classnames';

import PropTypes from 'prop-types';

import BigLetterN from '../icons/landing/BigLetterN';
import BigLetterT from '../icons/landing/BigLetterT';
import BigLetterE from '../icons/landing/BigLetterE';
import Logo from '../icons/landing/Logo';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/pages/splash.scss';

const propTypes = {
    color: AppPropTypes.color.isRequired,
    style: PropTypes.object, // eslint-disable-line
    animate: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = { className: null, animate: false, style: null };

const SplashPage = React.forwardRef(({ color, style, animate, className }, ref) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.animate]: animate,
                    [className]: className !== null,
                },
            ])}
            ref={ref}
            style={{ color, ...style }}
        >
            <Logo className={classNames([styles.centerLogo])} />
            <div className={classNames([styles.letterContainer, styles.containerN])}>
                <BigLetterN className={classNames([styles.letter, styles.letterN])} />
            </div>
            <div className={classNames([styles.letterContainer, styles.containerT])}>
                <BigLetterT className={classNames([styles.letter, styles.letterT])} />
            </div>
            <div className={classNames([styles.letterContainer, styles.containerE])}>
                <BigLetterE className={classNames([styles.letter, styles.letterE])} />
            </div>
        </div>
    );
});

SplashPage.propTypes = propTypes;
SplashPage.defaultProps = defaultProps;

export default SplashPage;
